var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"currentcolor","fill":"none","fillRule":"evenodd","strokeLinecap":"round"},React.createElement("g",{"id":"Mobile-Menu","transform":"translate(-287.000000, -13.000000)","strokeWidth":"2.5"},React.createElement("g",{"id":"Group","transform":"translate(288.000000, 14.000000)"},[React.createElement("path",{"d":"M-2.52081528,9.5 L21.5208153,9.5","id":"Line-4","transform":"translate(9.500000, 9.500000) rotate(-315.000000) translate(-9.500000, -9.500000) ","key":0}),React.createElement("path",{"d":"M-2.52081528,9.5 L21.5208153,9.5","id":"Line-4","transform":"translate(9.500000, 9.500000) rotate(-45.000000) translate(-9.500000, -9.500000) ","key":1})]))));
}

Close.defaultProps = {"width":"21px","height":"21px","viewBox":"0 0 21 21","version":"1.1"};

module.exports = Close;

Close.default = Close;
